const IOS_APP_USER_AGENT_MARKER = /MobileAppVersion/i;
const IOS_APP_VERSION_PATTERN = /MobileAppVersion\/(\d+\.\d+\.\d+)/i;

export const isIosApp = (userAgent: string) => {
  return IOS_APP_USER_AGENT_MARKER.test(userAgent);
};

const parseVersion = (version: string) => version.split('.').map(Number);

const compareIosAppVersion = (
  userAgent: string,
  minVersion: string,
): -1 | 0 | 1 => {
  const match = userAgent.match(IOS_APP_VERSION_PATTERN);

  if (!match) return -1;

  const current = parseVersion(match[1]);
  const min = parseVersion(minVersion);

  for (let i = 0; i < 3; i += 1) {
    if (current[i] > min[i]) return 1;
    if (current[i] < min[i]) return -1;
  }

  return 0;
};

export const iosAppVersionGreaterThan = (
  userAgent: string,
  minVersion: string,
): boolean => compareIosAppVersion(userAgent, minVersion) > 0;

export const iosAppVersionGreaterThanOrEqualTo = (
  userAgent: string,
  minVersion: string,
): boolean => compareIosAppVersion(userAgent, minVersion) >= 0;
